<template>
  <div>
    <a href="https://www.qpmarkets.com/wenno/" target="_blank">
      <img :src="b2_mobile" class="hidden-lg-and-up" style="width: 100%"/>
      <img :src="b2" class="hidden-md-and-down" style="width: 100%"/>
    </a>
    <router-link to="/collections">
      <img :src="b1" style="width: 100%"/>
    </router-link>
  </div>
</template>

<script>
import b2_en from '@/assets/img/home/qpmn_en.jpg';
import b2_mobile_en from '@/assets/img/home/qpmn_mobile_en.jpg';
import b2_mobile_zh from '@/assets/img/home/qpmn_mobile_zh.jpg';
import b2_zh from '@/assets/img/home/qpmn_zh.jpg';
import b1_en from '@/assets/img/home/toy_collections_en.jpg';
import b1_zh from '@/assets/img/home/toy_collections_zh.jpg';

export default {
  computed: {
    b1 () {
      return this.$i18n.locale === 'en' ? b1_en : b1_zh;
    },
    b2 () {
      return this.$i18n.locale === 'en' ? b2_en : b2_zh;
    },
    b2_mobile () {
      return this.$i18n.locale === 'en' ? b2_mobile_en : b2_mobile_zh;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/common/ToysCollection.vue